<div class="chip-row">
  <span
    *ngFor="let client of selectedClients"
    class="client-chip"
  >
    {{ client.name }}
    <button
      type="button"
      class="chip-remove"
      (click)="$event.stopPropagation(); removeClient(client)"
    ><i class="material-icons">close</i></button>
  </span>

  <input
    #chipInput
    class="client-text-input"
    [placeholder]="selectedClients.length === 0 ? placeholder : ''"
    [(ngModel)]="searchTerm"
    (input)="onSearchChange(chipInput.value)"
    (keydown.backspace)="onBackspace(chipInput)"
    [matAutocomplete]="clientAuto"
    autocomplete="off"
  />

  <mat-icon class="chip-chevron">expand_more</mat-icon>
</div>

<mat-autocomplete
  #clientAuto="matAutocomplete"
  [displayWith]="displayEmpty"
  (optionSelected)="onSelect($event.option.value)"
>
  <mat-option
    *ngFor="let result of searchResults"
    [value]="result"
    class="client-option"
  >
    <span class="option-name">{{ result.name }}</span>
  </mat-option>
  <mat-option
    *ngIf="isSearching"
    disabled
    class="no-results-option"
  >
    Searching…
  </mat-option>
  <mat-option
    *ngIf="!isSearching && searchResults.length === 0 && searchTerm.length >= 2"
    disabled
    class="no-results-option"
  >
    No clients found
  </mat-option>
</mat-autocomplete>
